import { render, staticRenderFns } from "./DeclareVente.vue?vue&type=template&id=54e9536d&scoped=true&"
import script from "./DeclareVente.vue?vue&type=script&lang=js&"
export * from "./DeclareVente.vue?vue&type=script&lang=js&"
import style0 from "./DeclareVente.vue?vue&type=style&index=0&id=54e9536d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e9536d",
  null
  
)

export default component.exports